import { LocalizationText } from "@/app/index";
import { Result } from "@/base/components/index";
import { ButtonLink } from "@/components/button-link/index";
import { usePageContextErrorBoundary } from "../../context/index";
import PageError404Svg from "../../static/page-error-404.svg?react";
import { usePageError404Styles } from "./page-error-404.styles";

export const PageError404 = () => {
  const { styles } = usePageError404Styles();
  const { localization } = usePageContextErrorBoundary();

  return (
    <Result
      className={styles.root}
      icon={<PageError404Svg />}
      title={<LocalizationText value="error.boundary.page.error.404.title" />}
      subTitle={
        <LocalizationText value="error.boundary.page.error.404.description" />
      }
      extra={
        <ButtonLink to={`/${localization.currentLang}/home`} type="primary">
          <LocalizationText value="error.boundary.page.error.404.button.text" />
        </ButtonLink>
      }
    />
  );
};
